import NumberRange from '../components/Filters/NumberRange';
import TextRange from '../components/Filters/TextRange';
import DatePickerRange from '../components/Filters/DatePickerRange';
import BooleanSelect from '../components/Filters/BooleanSelect';
import GridSelect from '../components/Filters/GridSelect';
var isDefined = function (val) { return typeof val !== 'undefined'; };
export var getActionCellSizeProps = function (column) {
    return {
        flexBasis: column.flexBasis,
        flexGrow: 0,
        flexShrink: 0,
    };
};
export var getCellSizeProps = function (column, columnWidth) {
    if (!column)
        return {};
    var fixedSize = column.fixedSize, flexGrow = column.flexGrow, flexShrink = column.flexShrink, sticky = column.sticky;
    return {
        flexBasis: columnWidth,
        flexGrow: fixedSize ? 0 : isDefined(flexGrow) ? flexGrow : 1,
        flexShrink: isDefined(flexShrink) ? flexShrink : 1,
        maxWidth: sticky ? columnWidth : 'auto',
    };
};
export var getSortName = function (column) {
    return column.systemName || column.name;
};
export var getFilterName = function (column) {
    return column.systemFilter || column.systemName || column.name;
};
export var isColumnOn = function (column, columnConfig) {
    var _a;
    if (column.alwaysOn)
        return true;
    var isHidden = (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig[column.name]) === null || _a === void 0 ? void 0 : _a.isHidden;
    if (typeof isHidden === 'boolean')
        return !isHidden; // isHidden is defined/stored => use user value
    if (!!column.defaultHidden && !!(columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig[column.name]))
        return true; // is default hidden but activated
    else
        return !column.defaultHidden;
};
export var calculatePaginator = function (page, rowsPerPage) { return ({
    offset: rowsPerPage ? rowsPerPage * (page - 1) : rowsPerPage,
    limit: rowsPerPage,
}); };
export var createFilterType = function (columnDefinition) {
    if (columnDefinition.filterOptions)
        return 'options';
    else
        return columnDefinition.filteringType || 'text';
};
export var getGroups = function (columns) {
    return columns.map(function (column, key) {
        var previousGroup = key > 0 && columns[key - 1].group;
        return {
            name: column.group,
            start: !!(column.group && (!previousGroup || (previousGroup && previousGroup !== column.group))),
            end: !!(column.group && (!columns[key + 1] || columns[key + 1].group !== column.group)),
        };
    });
};
export var getGroupClassNames = function (group) {
    return "".concat((group === null || group === void 0 ? void 0 : group.start) ? 'group-start' : '', " ").concat((group === null || group === void 0 ? void 0 : group.end) ? 'group-end' : '');
};
export var getStickyCollClassNames = function (sticky, stickTo) {
    return !sticky ? '' : "".concat(stickTo ? " sticky sticky-".concat(stickTo) : ' sticky sticky-left');
};
export var getFilters = function (optimizeFilters) {
    var filters = {
        number: { CellComponent: NumberRange },
        text: { CellComponent: TextRange },
        date: { CellComponent: DatePickerRange },
        flag: { CellComponent: BooleanSelect },
        options: { CellComponent: GridSelect },
    };
    if (optimizeFilters) {
        filters.text.defaultExtraProps = { defaultComparator: 'eq' };
    }
    return filters;
};
export var checksColumnsOrder = function (colsOrder, columnsDefinitions) {
    var stickyRightColls = columnsDefinitions.filter(function (col) { return col.sticky === true && col.stickTo === 'right'; });
    var stickyLeftColls = columnsDefinitions.filter(function (col) { return col.sticky === true && col.stickTo !== 'right'; });
    if (stickyLeftColls.length > 1 || stickyRightColls.length > 1) {
        console.error('Grid can have only sticky column on each side.');
    }
    if (stickyLeftColls.length && colsOrder.indexOf(stickyLeftColls[0].name) !== 0) {
        console.error('The left sticky column should be the first one in a row');
    }
    if (stickyRightColls.length && colsOrder.indexOf(stickyRightColls[0].name) !== colsOrder.length - 1) {
        console.error('The Right sticky column should be the last one in a row');
    }
};
